const ALIASES = {
  rv: 'RV Site',
  'rv site': 'RV Site',
  'rv sites': 'RV Site',
  'rv lot': 'RV Site',
  cabin: 'Cabin',
  cabins: 'Cabin',
  lodging: 'Lodge',
  lodge: 'Lodge',
  lodges: 'Lodge',
  tent: 'Tent',
  'tent site': 'Tent',
  'tent sites': 'Tent',
  glamping: 'Glamping',
  glamp: 'Glamping',
};

export function normalizeSiteCategory(raw) {
  if (raw == null || raw === '') return 'Other';
  const k = String(raw).trim().toLowerCase();
  if (!k) return 'Other';
  if (ALIASES[k]) return ALIASES[k];
  return k.charAt(0).toUpperCase() + k.slice(1);
}
